import { store } from '../../index';
import actionTypes from './actionTypes';

export const setAwsConfig = (awsConfigArray) => ({
  type: actionTypes.setAwsConfig,
  value: awsConfigArray,
});
